module.exports = __webpack_public_path__ + "media/images/badges/bft/milestone-10-inactive-bft-7a6baae99acd8bb0f014e48b0b7e0dd1.png";